import CustomSelectedRowCount from './customSelectedRowCount';
import CustomStatusBar from './customStatusBar';

const gridOptionsConfig = (moduleKey, navigate) => {
  const excludedModules = ['quoteList', 'salesOrder', 'invoice', 'productList', 'priceSheetList'];

  return {
    paginationPageSize: parseInt(process.env.REACT_APP_DEFAULT_PAGESIZE) || 20,
    paginationPageSizeSelector: [10, 20, 50, 100],
    suppressServerSideFullWidthLoadingRow: true,
    components: {
      customStatusBar: CustomStatusBar,
      CustomRowCountPanel: CustomSelectedRowCount,
    },
    context: {
      moduleKey,
      navigate,
    },
    statusBar: {
      statusPanels: [
        {
          statusPanel: 'customStatusBar',
          align: 'center',
        },
        // Only add this panel if moduleKey is not in excludedModules
        ...(!excludedModules.includes(moduleKey)
          ? [
              {
                statusPanel: 'CustomRowCountPanel',
                align: 'right',
              },
            ]
          : []),
      ],
    },
  };
};

export default gridOptionsConfig;

// This function creates a gridOptions object for AG Grid, which can be reused across different components.

// const gridOptions = {
//   paginationPageSize: process.env.REACT_APP_DEFAULT_PAGESIZE,
//   paginationPageSizeSelector: [10, 20, 50, 100],
//   suppressServerSideFullWidthLoadingRow: true,
//   components: {
//     customStatusBar: CustomStatusBar, // Ensure the correct reference
//     CustomRowCountPanel: CustomSelectedRowCount,
//   },
//   context: {
//     moduleKey: "salesOrder",
//     navigate,
//   },
//   statusBar: {
//     statusPanels: [
//       {
//         statusPanel: "customStatusBar",
//         align: "center",
//       },
//       {
//         statusPanel: "CustomRowCountPanel", // ✅ React component
//         align: "right",
//       },
//     ],
//   },
// };
